import { useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import { isAxiosError } from 'axios';

export interface GroupEntry {
  name: string;
  id: number;
}

const getGroups = async (signal?: AbortSignal): Promise<GroupEntry[]> => {
  const res = await apiClient.get<GroupEntry[]>(`/api/v1/groups`, {
    signal,
  });

  if (isAxiosError(res)) {
    const error = new Error('Get Groups Failed');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }
  return res.data;
};

interface UseOptions<TData> {
  config?: QueryConfig<typeof getGroups, TData>;
}

export const useGroups = <TData = GroupEntry[]>({ config }: UseOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 0,
    refetchOnMount: true,
    ...config,
    queryFn: ({ signal }) => getGroups(signal),
    queryKey: queryKeys.groups,
  });
};